import React from 'react';
import './Header.css';

const Header = () => {
    return (
        <div className='header-info'>
            <h1>Friends company</h1>
            <p>A good friend is like a four-leaf clover: hard to find and lucky to have</p>
            <h3>Total Budget: 2 Million</h3>
        </div>
    );
};

export default Header;